import React, { useEffect, useState } from "react"

import { Bar } from "react-chartjs-2"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from "prop-types";

const BarChartTodayPlanDaily = (props) => {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [data, setData] = useState({
    labels: [],
    datasets: [

      {
        label: "Entry (Daily Plan)",
        backgroundColor: "#ffd8b2",
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBorderWidth: 3,
        barPercentage: 0.7,
        hoverBackgroundColor: "#ffd8b2",
        hoverBorderColor: "#FFFFFF",
        data: [],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: '#ffd8b2',
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        }
      },

      {
        label: "Exit (Daily Plan)",
        backgroundColor: "#ffbf7f",
        borderColor: "#FFFFFF",
        borderWidth: 1,
        hoverBorderWidth: 3,
        barPercentage: 0.7,
        hoverBackgroundColor: "#ffbf7f",
        hoverBorderColor: "#FFFFFF",
        data: [],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: '#ffbf7f',
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        }
      },
    ],
  })


  const option = {
    maintainAspectRatio: false,
    // layout: {
    //   padding: {
    //     top: 35
    //   }
    // },
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 15,
          labelString: 'Supply-Demand',
          fontColor: "#FFFFFF",
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 15,
        },
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          fontSize: 15,
          labelString: 'MMscf',
          fontColor: "#FFFFFF",
          position: 'left',
          fontStyle: "bold",
        },
        gridLines: {
          display: true,
        },
        ticks: {
          stepSize: 1000,
          fontColor: "#FFFFFF",
          fontStyle: "bold",
          fontSize: 15,
          // max:0,
          min: 0,
          callback: function (label, index, labels) {
            // if (label > 999) return label / 1000 + "k"; ของเดิมบรรทัดเดียว มี หน่วย K
            return numberFormat(label, 0);
          },
        },
      }],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle:"bold",
      intersect: false,
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      }
      // , position: 'top'
    },


  }
  useEffect(() => {
    let newList = props.modelDeviceList.filter(
      item => item.SUPPLYDEMAND_NAME != "Total"
    );
    let groupData = newList.reduce((group, item) => {
      const { EXIT_SUPPLYDEMAND_ZONE } = item;
      group[EXIT_SUPPLYDEMAND_ZONE] = group[EXIT_SUPPLYDEMAND_ZONE] ?? [];
      group[EXIT_SUPPLYDEMAND_ZONE].push(item);
      return group;
    }, {});
    let newEntryExitList = Object.keys(groupData).map(key => {
      if (groupData[key].length > 1) {
        let sumPlanEntry = groupData[key].map(item => item.ACTIVITY_PLAN_ENTRY).reduce((prev, curr) => prev + curr, 0);
        let sumActualEntry = groupData[key].map(item => item.ACTIVITY_ACTUAL_ENTRY).reduce((prev, curr) => prev + curr, 0);
        return {
          ...groupData[key][0],
          SUPPLYDEMAND_NAME: groupData[key][0].EXIT_SUPPLYDEMAND_ZONE,
          ACTIVITY_PLAN_ENTRY: sumPlanEntry,
          ACTIVITY_ACTUAL_ENTRY: sumActualEntry
        };
      }

      return { ...groupData[key][0] };
    }).sort((a, b) => (a.EXIT_ROW > b.EXIT_ROW) ? 1 : ((b.EXIT_ROW > a.EXIT_ROW) ? -1 : 0));
    // let labels = newEntryExitList.map(item => item.SUPPLYDEMAND_NAME);
    let labels = newEntryExitList.map(item => item.SUPPLYDEMAND_NAME.indexOf(',') >= 0 ? item.SUPPLYDEMAND_NAME.substring(0, item.SUPPLYDEMAND_NAME.indexOf(',')) : item.SUPPLYDEMAND_NAME);

    let planEntryData = newEntryExitList.map(item =>
      item.ACTIVITY_PLAN_ENTRY
    );
    let actualEntryData = newEntryExitList.map(item =>
      item.ACTIVITY_ACTUAL_ENTRY
    );
    let planExitData = newEntryExitList.map(item =>
      item.ACTIVITY_PLAN_EXIT
    );
    let actualExitData = newEntryExitList.map(item =>
      item.ACTIVITY_ACTUAL_EXIT
    );
    // console.log(planExitData)
    setData(prev => {
      return {
        ...prev,
        labels: labels,
        datasets: [
          { ...prev.datasets[0], data: actualEntryData },
          { ...prev.datasets[1], data: actualExitData },
        ],
      };
    });
    // console.log(props.modelDeviceList)
  }, [props.modelDeviceList]);
  return (
    <React.Fragment>
      <Bar data={data} options={option} plugins={[ChartDataLabels]} />
      {/* width="100%" height="100%" */}
      {/* width={170} height={73} */}
    </React.Fragment>
  )

}
BarChartTodayPlanDaily.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  modelDeviceList: PropTypes.any,
};
export default BarChartTodayPlanDaily
